// MISSION SECTION ********************************          
$(window).on("load", function()   {                                                                             


    $(window).resize(function() {

      if ($("#MissionSection .col").css("float") === "none") {
         
         var contHeight = $("#MissionSection .col.content .continner").height();

         $("#MissionSection .col.content").css({"height": contHeight + 130});

         $("#MissionSection").css({"height": $("#MissionSection .col.content").height() + 300});

      }

      if ($("#MissionSection .col").css("float") === "left") {
         $("#MissionSection, #MissionSection .col.content").removeAttr("style");
      }

    }).resize();


});








// PRODUCT CAROUSEL SECTION ********************************          
$(window).on("load", function() {                                                                    



   // globals ***
   var done = true,
       carContainerWidth,
       carProductWidth,
       carProductWrapperWidth,
       carDisplayFactor;



   // set product width & position *** 
   $(window).on("resize", function() {

	  if ($("#ProductsCarouselSection #Header .controls .control.mobile").css("display") === "inline-block") {
	  	carDisplayFactor = 0.8;   
	  } 
	  else {  
	  	carDisplayFactor = 0.4;     
	  }

	  carContainerWidth = $("#ProductsCarousel").width();
	  carProductWidth = (carContainerWidth * carDisplayFactor) - 22.5;      
	  carProductWrapperWidth = (carProductWidth * 4) + 90; 

      $("#ProductsCarouselInner .prod").css({"width": carProductWidth });
      $("#ProductsCarouselInner").css({"width": carProductWrapperWidth });

      for (i = 0; i < 4; i++) { 
      	$("#ProductsCarouselInner").children("a").eq(i).find(".prod").css({"left": (carProductWidth * i) + (30 * i) }); 
      } 

   }).resize();



   // controls *** 
   $("#ProductsCarouselSection .controls .control").click(function() {

   	   if (!($(this).hasClass("active")) && done) {

   	   	   doneUtil();

		   $("#ProductsCarouselSection .controls .control.active").removeClass("active");
		   $(this).addClass("active");
		   
		   var num = $(this).attr("data-num");  

		   $("#ProductsCarouselInner").css({"left": (num * (carProductWidth + 30)) * -1  }); 

       }

   });  
   


   // done util ***
   function doneUtil() {
	  done = false;
      setTimeout(function() { done = true; }, 1000);
   }



   // reset carousel *** 
   function resetCar() {
      $("#ProductsCarouselInner").css({"left":"0px"}); 
	  $("#ProductsCarouselSection .controls .control.active").removeClass("active");
	  $("#ProductsCarouselSection .controls .control.one").addClass("active"); 
   }



   // make carousel draggable ***
   /*
   let isDragStart = false, isDragging = false, prevPageX, prevScrollLeft, positionDiff;
   const carousel = document.getElementById("ProductsCarousel"), firstImg = document.getElementById("ProdCarImg1");  

   // The Element.scrollLeft property gets or sets the number of pixels that an element's content is scrolled from its left edge.
   // The Element.scrollWidth read-only property is a measurement of the width of an element's content, including content not visible on the screen
   // clientWidth property is zero for inline elements and elements with no CSS; otherwise, it's the inner width of an element in pixels. 

   function autoSlide() {
      
      // console.log(carousel.scrollLeft, carousel.scrollWidth, carousel.clientWidth);

   	  if (carousel.scrollLeft - (carousel.scrollWidth - carousel.clientWidth) > -1 || carousel.scrollLeft <= 0) return;

      positionDiff = Math.abs(positionDiff);
      let firstImgWidth = firstImg.clientWidth + 14;
      let valDifference = firstImgWidth - positionDiff;

      if(carousel.scrollLeft > prevScrollLeft) {
         return carousel.scrollLeft += positionDiff > firstImgWidth / 4 ? valDifference : -positionDiff;
      }

      carousel.scrollLeft -= positionDiff > firstImgWidth / 4 ? valDifference : -positionDiff;

   }

   function dragStart(e) {
      isDragStart = true;
      prevPageX = e.pageX || e.touches[0].pageX;
      prevScrollLeft = carousel.scrollLeft;
   }

   function dragging(e) {
      if(!isDragStart) return;
      isDragging = true; 
      carousel.classList.add("dragging"); 
      positionDiff = (e.pageX || e.touches[0].pageX) - prevPageX;
      carousel.scrollLeft = prevScrollLeft - positionDiff;
   }

   function dragStop() {
      isDragStart = false; 
      carousel.classList.remove("dragging"); 
      if(!isDragging) return;
      isDragging = false;
      autoSlide();
   }

   carousel.addEventListener("mousedown", dragStart);
   carousel.addEventListener("touchstart", dragStart);

   document.addEventListener("mousemove", dragging);
   carousel.addEventListener("touchmove", dragging);

   document.addEventListener("mouseup", dragStop);
   document.addEventListener("mouseleave", dragStop);
   carousel.addEventListener("touchend", dragStop);
   */



}); 